import type { ReactNode } from 'react';
import { type VariantProps, tv } from 'tailwind-variants';

import type { CommonProps } from '../../../types';
import { Heading } from '../../../atoms';

export interface CardHeaderProps
    extends CommonProps,
        VariantProps<typeof CardHeaderStyles> {
    children?: ReactNode;
    title: string;
}

export const CardHeaderStyles = tv({
    slots: {
        root: 'flex flex-wrap items-baseline justify-between gap-x-7 pb-6',
    },
});

export const CardHeader = ({
    className,
    children,
    title,
    testId = 'card-header',
    ...props
}: CardHeaderProps): JSX.Element => {
    const { root } = CardHeaderStyles();
    return (
        <div className={root({ className })} data-testid={testId} {...props}>
            <Heading className="mb-0">{title}</Heading>
            {children}
        </div>
    );
};
